import { api } from '@api'
import { SupplierPurchaseOrder } from '@types'

interface GetPurchaseOrdersResponse {
  purchaseOrders: SupplierPurchaseOrder[]
}

const getSupplierPurchaseOrder = async () => {
  const response = await api.get<GetPurchaseOrdersResponse>('/supplier-purchase-order/')
  return response.data.purchaseOrders
}

export const SupplierPurchaseOrdersApi = {
  getSupplierPurchaseOrder,
}
